import {Reward} from "./reward";
import {OrgTable} from "./orgTable";
import {UserTasks} from "./userTasks";
import {LineItem} from './lineItem';
import {Time} from '@angular/common';
import { Address } from "./address.model";

export class OrgSetting {
  _id: string;
  orgUuid: string;
  name: string;
  dataSyncedWithPartner: boolean;
  image: string;
  heroImage: string;
  email: string;
  accountType: string;
  phoneNumber: number;
  merchantId: string;
  squareLocationId: string;
  squareLocationName: string;
  uberEatsStoreId: string;
  doordashStoreId: string;
  grubhubRestaurantId: string;
  customerReviewUrl: string;
  currency_code: string;
  uniqueOrgIdent: string;
  userTasks: UserTasks[];
  featuresEnabled: {
    serverTableMove: boolean;
    jukeboxEnabled: boolean;
    reservationsEnabled: boolean;
    marketingEnabled: boolean;
    hideGratuityOnTable: boolean;
    serverOrderEdit: boolean;
    v1Print: boolean;
    printAllPaidOrders: boolean;
    addressEnabled: boolean;
    websiteEnabled: boolean;
    onlineOrderingSelfDelivery?: boolean;
    enableLabelPrinting?: boolean;
    smartMenuBuilderEnabled?: boolean;
    aiUpsellEnabled?: boolean;
    tippingEnabled?: boolean;
    timeClockEnabled?: boolean;
    receiptScreenEnabled?: boolean;
    drivenThruConfirmationDisplayEnabled?: boolean;
    // Route in-person card capture through a locally attached Clover Go reader
    // (DineNGo Android Runner) instead of a networked Clover device. Additive;
    // off by default so existing on-device flows are unchanged.
    cloverGoTerminalEnabled?: boolean;
    // Back / customer confirmation display branding logo source. FALSE (default)
    // shows the DineNGo badge; TRUE shows the merchant's own business logo
    // (orgSettings.image). Additive and off by default so every display keeps
    // the DineNGo logo until this is flipped on. The switch is present in
    // Organization settings but hidden for now.
    confirmationDisplayUseBusinessLogo?: boolean;
    // Fire the kitchen/order ticket when the cashier tenders an existing
    // open/table order via Pay without first pressing Save. Default ON; only an
    // explicit `false` disables it, so legacy orgs (field absent) keep the new
    // behavior. The backend per-item `printed` dedup guarantees Save-then-Pay
    // still yields a single ticket. See cashier-register's
    // _fireExistingOrderKitchenOnPay.
    fireKitchenOnPayIfUnprinted?: boolean;
  };
  availablePrinterLabels?: string[];
  orderTypesEnabled: {
    carryout: boolean;
    dineIn: boolean;
    delivery: boolean;
    deliveryFee: LineItem;
    deliveryRadius: number;
  };
  businessHours: {
    monday: {
      openTime: Time;
      closeTime: Time;
    },
    tuesday: {
      openTime: Time;
      closeTime: Time;
    },
    wednesday: {
      openTime: Time;
      closeTime: Time;
    },
    thursday: {
      openTime: Time;
      closeTime: Time;
    },
    friday: {
      openTime: Time;
      closeTime: Time;
    },
    saturday: {
      openTime: Time;
      closeTime: Time;
    },
    sunday: {
      openTime: Time;
      closeTime: Time;
    },
  };
  tables: OrgTable[];
  additionalLayouts: any;
  rewards: Reward;
  cashDiscount: {
    enabled: boolean;
    percent: number;
    pricesAdjusted: boolean;
  };
  address: Address;
  menuSortOrder: {
    categories: { [id: string]: number };
    items: { [id: string]: number };
  };
  modifiedDate: Date;
  createdDate: string;
  temiPosition: {
    x: number,
    y: number,
    yaw: number,
    tiltAngle: number
  };
  dinengoDelivery?: {
    enabled: boolean;
    adminApproved: boolean;
    markupCents: number;
    providers: {
      doordashDrive: boolean;
      uberDirect: boolean;
    };
  };
  publicPayment?: {
    allowUninvoicedOrders: boolean;
  };
  timezone?: string;
  payPolicy?: {
    workweekStartDow: number;
    overtimeWeeklyMinutes: number;
    overtimeMultiplier: number;
  };
  cashierRegisterSettings?: any;
  introPromo?: {
    enabled: boolean;
    promoId: string;
    showOnKiosk: boolean;
    autoApplyOnSignup: boolean;
  };
  offlineMode?: {
    enabled: boolean;
    maxTransactionCents: number;   // 0 = unlimited; blocks offline payments above this
    requireManualConfirmation: boolean;  // Always require "Payment Received" tap
    localConnectorEnabled: boolean;      // Phase 2: try LAN WebSocket first
    localConnectorIp?: string;           // Phase 2: cached Clover device IP
  };
  // Standby / screensaver for customer-facing devices. Optional + off by
  // default so existing orgs are unaffected until they opt in.
  kioskStandby?: {
    enabled: boolean;
    idleTimeoutSeconds: number;   // inactivity before the screensaver engages
    slideDurationSeconds: number; // how long each image shows before crossfade
  };
}
